import React, { useState } from 'react';
import '../LegalPages.css';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Toutes', icon: '📋' },
    { id: 'commandes', name: 'Commandes', icon: '🛒' },
    { id: 'livraison', name: 'Livraison', icon: '🚚' },
    { id: 'paiement', name: 'Paiement', icon: '💳' },
    { id: 'produits', name: 'Produits', icon: '🪑' },
    { id: 'retours', name: 'Retours', icon: '↩️' },
    { id: 'garantie', name: 'Garantie', icon: '🛡️' }
  ];

  const faqs = [
    // Commandes
    {
      category: 'commandes',
      question: 'Comment passer une commande sur votre site?',
      answer: 'Pour passer commande : 1) Parcourez notre catalogue et ajoutez les produits souhaités à votre panier. 2) Cliquez sur l\'icône panier et vérifiez votre commande. 3) Cliquez sur "Passer la commande" et remplissez vos informations. 4) Choisissez votre mode de paiement et validez. Vous recevrez une confirmation par email.'
    },
    {
      category: 'commandes',
      question: 'Puis-je modifier ma commande après validation?',
      answer: 'Vous pouvez modifier votre commande dans les 2 heures suivant sa validation en nous contactant par téléphone ou email. Après ce délai, si la commande est déjà en préparation, les modifications ne seront plus possibles.'
    },
    {
      category: 'commandes',
      question: 'Comment annuler ma commande?',
      answer: 'Pour annuler une commande, contactez-nous immédiatement par téléphone ou email. Si la commande n\'a pas encore été expédiée, l\'annulation sera gratuite. Si elle est déjà en cours d\'expédition, vous devrez attendre la livraison et procéder à un retour selon notre politique de retours.'
    },
    {
      category: 'commandes',
      question: 'Puis-je commander sans créer de compte?',
      answer: 'Actuellement, un compte est nécessaire pour passer commande. Cela nous permet de mieux gérer votre commande, de vous tenir informé du suivi, et de vous offrir un historique d\'achats. L\'inscription est rapide et gratuite.'
    },
    
    // Livraison
    {
      category: 'livraison',
      question: 'Quels sont les délais de livraison?',
      answer: 'Les délais varient selon votre localisation : Alger : 2-3 jours ouvrables, Grandes villes : 3-5 jours ouvrables, Autres wilayas : 5-7 jours ouvrables. Ces délais sont indicatifs et peuvent varier selon la disponibilité des produits et les conditions de transport.'
    },
    {
      category: 'livraison',
      question: 'Livrez-vous dans toute l\'Algérie?',
      answer: 'Oui, nous livrons dans les 58 wilayas d\'Algérie. Les frais de livraison sont calculés automatiquement en fonction de votre adresse lors du passage de commande.'
    },
    {
      category: 'livraison',
      question: 'Comment suivre ma commande?',
      answer: 'Après expédition, vous recevrez un email avec un numéro de suivi. Vous pouvez également suivre votre commande depuis votre espace client en vous connectant à votre compte. Notre service client est disponible pour vous renseigner sur l\'état de votre livraison.'
    },
    {
      category: 'livraison',
      question: 'Que faire si je ne suis pas présent lors de la livraison?',
      answer: 'Le livreur vous contactera avant de se présenter. Si vous êtes absent, il pourra soit repasser, soit laisser le colis à une personne de confiance (avec votre autorisation préalable). Contactez-nous rapidement pour convenir d\'une nouvelle date de livraison.'
    },
    {
      category: 'livraison',
      question: 'Proposez-vous l\'installation des meubles?',
      answer: 'Oui, nous proposons un service d\'installation professionnel pour tous nos produits. Le tarif varie selon le type de meuble et votre localisation. Cette option vous sera proposée lors du passage de commande.'
    },

    // Paiement
    {
      category: 'paiement',
      question: 'Quels modes de paiement acceptez-vous?',
      answer: 'Nous acceptons : 1) Paiement à la livraison en espèces, 2) Virement bancaire, 3) Chèque (clients professionnels uniquement). Les informations de paiement vous seront communiquées après validation de votre commande.'
    },
    {
      category: 'paiement',
      question: 'Le paiement en ligne est-il sécurisé?',
      answer: 'Actuellement, nous n\'acceptons pas les paiements en ligne par carte bancaire. Nous travaillons sur l\'intégration de cette fonctionnalité avec les protocoles de sécurité les plus stricts. En attendant, vous pouvez payer à la livraison ou par virement bancaire.'
    },
    {
      category: 'paiement',
      question: 'Puis-je payer en plusieurs fois?',
      answer: 'Oui, pour les commandes professionnelles ou les montants importants (supérieurs à 100 000 DZD), nous proposons des facilités de paiement. Contactez notre service commercial pour étudier votre dossier et établir un plan de paiement adapté.'
    },
    {
      category: 'paiement',
      question: 'Proposez-vous des factures pour entreprises?',
      answer: 'Oui, nous délivrons des factures conformes à la législation algérienne pour toutes les commandes. Les entreprises peuvent demander une facture pro-forma avant paiement. Toutes nos factures incluent la TVA et sont téléchargeables depuis votre espace client.'
    },

    // Produits
    {
      category: 'produits',
      question: 'Vos produits sont-ils garantis?',
      answer: 'Oui, tous nos produits bénéficient d\'une garantie de 5 ans (hors accessoires et pièces d\'usure). Cette garantie couvre les défauts de fabrication et de matériaux. Consultez notre page Garantie pour plus de détails.'
    },
    {
      category: 'produits',
      question: 'Puis-je voir les produits avant d\'acheter?',
      answer: 'Oui, nous vous invitons à visiter notre showroom à Alger où vous pourrez voir et tester nos produits. La visite est gratuite et nos conseillers sont à votre disposition pour vous guider. Prenez rendez-vous via notre page Contact.'
    },
    {
      category: 'produits',
      question: 'Proposez-vous du mobilier sur mesure?',
      answer: 'Oui, nous réalisons des meubles sur mesure pour répondre à vos besoins spécifiques. Contactez notre service commercial avec vos dimensions et exigences. Nous vous fournirons un devis personnalisé sous 48-72 heures.'
    },
    {
      category: 'produits',
      question: 'Les produits sont-ils montés à la livraison?',
      answer: 'Certains produits sont livrés montés, d\'autres nécessitent un assemblage. Cette information est précisée sur chaque fiche produit. Si vous souhaitez un service d\'assemblage, vous pouvez le sélectionner lors de la commande (service payant).'
    },
    {
      category: 'produits',
      question: 'Quelle est la différence entre vos gammes de produits?',
      answer: 'Nous proposons trois gammes : Essential (rapport qualité-prix excellent, design moderne), Premium (matériaux haut de gamme, ergonomie avancée), et Executive (luxe, prestige, finitions exceptionnelles). Chaque gamme répond à des besoins et budgets différents.'
    },

    // Retours
    {
      category: 'retours',
      question: 'Puis-je retourner un produit?',
      answer: 'Oui, vous disposez de 14 jours à compter de la réception pour exercer votre droit de rétractation. Le produit doit être dans son emballage d\'origine, non utilisé et avec tous ses accessoires. Les frais de retour sont à votre charge sauf en cas de produit défectueux.'
    },
    {
      category: 'retours',
      question: 'Comment procéder à un retour?',
      answer: 'Pour retourner un produit : 1) Contactez notre service client dans les 14 jours. 2) Nous vous fournirons un numéro de retour (RMA). 3) Emballez soigneusement le produit. 4) Expédiez-le à l\'adresse indiquée. 5) Le remboursement sera effectué sous 14 jours après réception.'
    },
    {
      category: 'retours',
      question: 'Que faire si mon produit arrive endommagé?',
      answer: 'Si votre produit arrive endommagé : 1) Refusez le colis ou notez les dommages sur le bon de livraison. 2) Prenez des photos. 3) Contactez-nous immédiatement (max 48h). 4) Nous organiserons un retour gratuit et un remplacement ou remboursement.'
    },
    {
      category: 'retours',
      question: 'Les produits sur mesure sont-ils remboursables?',
      answer: 'Non, les produits fabriqués sur mesure selon vos spécifications ne sont pas éligibles au droit de rétractation, conformément à la loi. Assurez-vous de bien vérifier toutes les dimensions et spécifications avant de valider votre commande personnalisée.'
    },

    // Garantie
    {
      category: 'garantie',
      question: 'Comment fonctionne votre garantie de 5 ans?',
      answer: 'Notre garantie de 5 ans couvre tous les défauts de fabrication et de matériaux. Elle ne couvre pas l\'usure normale, les dommages accidentels ou une mauvaise utilisation. Pour faire valoir la garantie, contactez-nous avec votre numéro de commande et des photos du problème.'
    },
    {
      category: 'garantie',
      question: 'Que couvre exactement la garantie?',
      answer: 'La garantie couvre : défauts de fabrication, problèmes de mécanismes (vérins, roulettes), défauts de matériaux, problèmes de structure. Elle ne couvre pas : usure normale, taches, éraflures, dommages dus à une mauvaise utilisation, modifications non autorisées.'
    },
    {
      category: 'garantie',
      question: 'Comment faire une réclamation sous garantie?',
      answer: 'Pour une réclamation : 1) Contactez notre SAV avec votre numéro de commande. 2) Décrivez le problème et envoyez des photos. 3) Nous évaluerons la réclamation sous 48h. 4) Si acceptée, nous procéderons à la réparation, au remplacement ou au remboursement selon le cas.'
    },
    {
      category: 'garantie',
      question: 'Puis-je prolonger ma garantie?',
      answer: 'Nous proposons une extension de garantie jusqu\'à 10 ans sur certains produits. Cette extension doit être souscrite au moment de l\'achat. Contactez notre service commercial pour connaître les tarifs et conditions.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFaqs = activeCategory === 'all' 
    ? faqs 
    : faqs.filter(faq => faq.category === activeCategory);

  return (
    <div className="legal-page faq-page">
      <div className="classjustforheadercolor"></div>
      <Header />
      
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero__content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              <span>Centre d'Aide</span>
            </div>
            
            <h1 className="legal-hero__title">
              Questions <span className="title-highlight">Fréquemment Posées</span>
            </h1>
            
            <p className="legal-hero__subtitle">
              Trouvez rapidement des réponses à vos questions sur nos produits, services et politiques.
            </p>
          </div>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="faq-categories">
        <div className="container">
          <div className="faq-categories__grid">
            {categories.map(category => (
              <button
                key={category.id}
                className={`faq-category-btn ${activeCategory === category.id ? 'faq-category-btn--active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <span className="faq-category-btn__icon">{category.icon}</span>
                <span className="faq-category-btn__name">{category.name}</span>
                <span className="faq-category-btn__count">
                  {category.id === 'all' ? faqs.length : faqs.filter(f => f.category === category.id).length}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content">
        <div className="container">
          <div className="legal-grid">
            {/* Main Content */}
            <div className="legal-main">
              <div className="faq-list">
                {filteredFaqs.map((faq, index) => (
                  <div key={index} className={`faq-item ${openIndex === index ? 'faq-item--open' : ''}`}>
                    <button 
                      className="faq-item__question"
                      onClick={() => toggleFAQ(index)}
                    >
                      <span className="faq-item__question-text">{faq.question}</span>
                      <svg 
                        className="faq-item__icon" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </button>
                    <div className="faq-item__answer">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Contact CTA */}
              <div className="faq-cta">
                <div className="faq-cta__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                  </svg>
                </div>
                <h3 className="faq-cta__title">Vous ne trouvez pas la réponse?</h3>
                <p className="faq-cta__text">
                  Notre équipe est là pour vous aider. Contactez-nous et nous vous répondrons rapidement.
                </p>
                <div className="faq-cta__buttons">
                  <Link to="/contact" className="btn-primary">
                    Nous Contacter
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </Link>
                  <a href="tel:++213 560 60 56 55" className="btn-outline">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                    </svg>
                    Appeler
                  </a>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Catégories Populaires</h3>
                <nav className="legal-sidebar__nav">
                  <a href="#" className="legal-sidebar__link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                    </svg>
                    Commandes & Paiement
                  </a>
                  <a href="#" className="legal-sidebar__link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="1" y="3" width="15" height="13"/>
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                      <circle cx="5.5" cy="18.5" r="2.5"/>
                      <circle cx="18.5" cy="18.5" r="2.5"/>
                    </svg>
                    Livraison & Suivi
                  </a>
                  <a href="#" className="legal-sidebar__link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                    Compte & Sécurité
                  </a>
                  <a href="#" className="legal-sidebar__link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    Support & Garantie
                  </a>
                </nav>
              </div>

              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Documents Utiles</h3>
                <div className="legal-sidebar__links">
                  <Link to="/terms" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Conditions Générales
                  </Link>
                  <Link to="/privacy" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    Politique de Confidentialité
                  </Link>
                  <Link to="/cookies" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="16" x2="12" y2="12"/>
                      <line x1="12" y1="8" x2="12.01" y2="8"/>
                    </svg>
                    Politique de Cookies
                  </Link>
                </div>
              </div>

              <div className="legal-sidebar__card legal-sidebar__card--highlight">
                <div className="legal-sidebar__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/>
                  </svg>
                </div>
                <h3 className="legal-sidebar__title">Support Client</h3>
                <p className="legal-sidebar__text">
                  Du lundi au samedi<br/>
                  9h00 - 18h00
                </p>
                <a href="tel:+213 560 60 56 55" className="legal-sidebar__btn">
                  +213 560 60 56 55
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
                <a href="tel:+213 560 39 42 54" className="legal-sidebar__btn">
                 +213 560 39 42 54
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;